import { StopIcon, SuccessIcon, Table } from "melco-ui";
import { useTranslation } from "react-i18next";
import { MelcoModelsUserActivityListItem } from "melco-shared-logic";
import { useUserHistory } from "../../../hooks/users/useUserHistory";

type LicensesListPropTypes = {
  userId: string;
  productCode: string;
};

export const UserHistoryList: React.FC<LicensesListPropTypes> = ({
  userId,
  productCode,
}) => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
  } = useUserHistory(userId, productCode);
  const { t } = useTranslation();

  const columns = [
    {
      title: t("users.tabs.history.table.columns.activity"),
      key: "activity",
      dataIndex: "activity",
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.history.table.columns.created_on"),
      key: "created_on",
      //dataIndex: "product_code",
      // sorter: true,
      width: 30,
      render: (rowObj: MelcoModelsUserActivityListItem) => {
        return (
          <>
            {rowObj.created_on
              ? new Date(rowObj.created_on).toLocaleString()
              : ""}
          </>
        );
      },
    },
    {
      title: t("users.tabs.history.table.columns.ip_address"),
      key: "ip_address",
      dataIndex: "ip_address",
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.history.table.columns.device_name"),
      key: "device_name",
      dataIndex: "device_name",
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.history.table.columns.app_version"),
      key: "app_version",
      dataIndex: "app_version",
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.history.table.columns.os_name"),
      key: "os_name",
      dataIndex: "os_name",
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.history.table.columns.os_version"),
      key: "os_version",
      dataIndex: "os_version",
      //sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.history.table.columns.is_successful"),
      key: "is_successful",
      //dataIndex: "is_successful",
      render: (rowObj: MelcoModelsUserActivityListItem) => {
        return <>{rowObj.is_successful ? <SuccessIcon /> : <StopIcon />}</>;
      },
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.history.table.columns.comments"),
      key: "comments",
      dataIndex: "comments",
      // sorter: true,
      width: 30,
    },
  ];

  return (
    <>
      <div>
        <Table
          //  showSorterTooltip={false}
          sticky
          loading={isPreviousData ? isFetching : isLoading}
          dataSource={data}
          columns={columns}
          onChange={onTableConfigChange}
          //pagination={pagination}
          pagination={false}
          rowKey="id"
          // rowSelection={rowSelection}
          // onRow={onRow}
          noDataMessage={t("users.tabs.history.table.no_data_message")}
          errorComponent={errorComponent}
        //scroll={{ x: 1700 }}
        />
      </div>
    </>
  );
};
